const ABNORMAL = 0;
const NOT_STARTED = 1;
const IN_PROGRESS = 3;
const FIRST_SET = 51;
const FIRST_PAUSE = 331;
const SECOND_SET = 52;
const SECOND_PAUSE = 332;
const THIRD_SET = 53;
const THIRD_PAUSE = 333;
const FOURTH_SET = 54;
const FOURTH_PAUSE = 334;
const FIFTH_SET = 55;
const ENDED = 100;
const WALKOVER = 20;
const RETIRED = 21;
const WALKOVER1 = 22;
const WALKOVER2 = 23;
const RETIRED1 = 24;
const RETIRED2 = 25;
const DEFAULTED1 = 26;
const DEFAULTED2 = 27;
const POSTPONED = 14;
const DELAYED = 15;
const CANCELED = 16;
const INTERRUPTED = 17;
const CUT_IN_HALF = 19;
const TO_BE_DETERMINED = 99;

// Match Status
const POINTS_WON = 1;
const MAX_POINTS_IN_A_ROW = 2;
const MATCH_POINTS = 3;
const COMEBACK_TO_WIN = 4;
const BIGGEST_LEAD = 5;
const SERVICE_ERRORS = 6;
const SERVICE_POINTS_SUCCESS = 7;
const SERVICE_POINTS_TOTAL = 8;
const SERVICE_POINTS_RATE = 9;
const RECEIVER_POINTS_SUCCESS = 10;
const RECEIVER_POINTS_TOTAL = 11;
const RECEIVER_POINTS_RATE = 12;

const LIST_NOT_PLAYING = [
  ABNORMAL,
  NOT_STARTED,
  ENDED,
  WALKOVER,
  RETIRED,
  WALKOVER1,
  WALKOVER2,
  RETIRED1,
  RETIRED2,
  DEFAULTED1,
  DEFAULTED2,
  POSTPONED,
  DELAYED,
  CANCELED,
  INTERRUPTED,
  CUT_IN_HALF,
  TO_BE_DETERMINED,
];

const LIST_PLAYING = [
  IN_PROGRESS,
  FIRST_SET,
  FIRST_PAUSE,
  SECOND_SET,
  SECOND_PAUSE,
  THIRD_SET,
  THIRD_PAUSE,
  FOURTH_SET,
  FOURTH_PAUSE,
  FIFTH_SET,
];

export = {
  ABNORMAL,
  NOT_STARTED,
  IN_PROGRESS,
  FIRST_SET,
  FIRST_PAUSE,
  SECOND_SET,
  SECOND_PAUSE,
  THIRD_SET,
  THIRD_PAUSE,
  FOURTH_SET,
  FOURTH_PAUSE,
  FIFTH_SET,
  ENDED,
  WALKOVER,
  RETIRED,
  WALKOVER1,
  WALKOVER2,
  RETIRED1,
  RETIRED2,
  DEFAULTED1,
  DEFAULTED2,
  POSTPONED,
  DELAYED,
  CANCELED,
  INTERRUPTED,
  CUT_IN_HALF,
  TO_BE_DETERMINED,

  // Match Status
  POINTS_WON,
  MAX_POINTS_IN_A_ROW,
  MATCH_POINTS,
  COMEBACK_TO_WIN,
  BIGGEST_LEAD,
  SERVICE_ERRORS,
  SERVICE_POINTS_SUCCESS,
  SERVICE_POINTS_TOTAL,
  SERVICE_POINTS_RATE,
  RECEIVER_POINTS_SUCCESS,
  RECEIVER_POINTS_TOTAL,
  RECEIVER_POINTS_RATE,

  // group status not playing
  LIST_NOT_PLAYING,

  LIST_PLAYING,

  MATCH_STATUS_TEXT: {
    0: "Bất thường (Đề nghị ẩn)",
    1: "Chưa bắt đầu",
    3: "Đang diễn ra",
    51: "SET 1",
    331: 'Tạm dừng 1',
    52: "SET 2",
    332: 'Tạm dừng 2',
    53: "SET 3",
    333: 'Tạm dừng 3',
    54: "SET 4",
    334: 'Tạm dừng 4',
    55: "SET 5",
    100: "Kết thúc",
    20: "Thắng ván",
    21: "Rút lui",
    22: "Thắng ván 1",
    23: "Thắng ván 2",
    24: "Rút lui 1",
    25: "Rút lui 2",
    26: "Mất quyền thi đấu 1",
    27: "Mất quyền thi đấu 2",
    14: "Hoãn lại",
    15: "Bị trễ",
    16: "Đã hủy",
    17: "Gián đoạn",
    18: "Tạm dừng",
    19: "Cắt đôi",
    99: "Chưa xác định",
  },

  MATCH_STATUS_ACTIVE: [
    POINTS_WON,
    MAX_POINTS_IN_A_ROW,
    MATCH_POINTS,
    COMEBACK_TO_WIN,
    BIGGEST_LEAD,
    SERVICE_ERRORS,
    SERVICE_POINTS_SUCCESS,
    SERVICE_POINTS_TOTAL,
    SERVICE_POINTS_RATE,
    RECEIVER_POINTS_SUCCESS,
    RECEIVER_POINTS_TOTAL,
    RECEIVER_POINTS_RATE,
  ],
};
